export { default } from './2026-10-05_RevisionContent';
export type { TermsRevision } from './types';
